import { Suspense } from 'react';
import LoadingSpinner from 'src/newSrc/components/LoadingSpinner/index';
import { getScreenComponent } from '../screenMappingConfig';
import { connect } from 'react-redux';

const DynamicScreen = props => {
  const { userInfo, screenComponentName } = props;
  const ScreenComponent = getScreenComponent(
    userInfo?.company_text_id,
    screenComponentName
  );

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ScreenComponent />
    </Suspense>
  );
};

const mapStateToProps = state => ({
  userInfo: state.authentication.userInfo,
});

export default connect(mapStateToProps)(DynamicScreen);
